import { ref } from 'vue';
import type { EIconNameType } from '@/core/components/ui/EIcon/EIcon.type';

export type ErrorSnackbarConfig = {
  title: string;
  icon: EIconNameType;
};

const config = ref<ErrorSnackbarConfig>();
const isShown = ref(false);

export const useErrorSnackbar = () => {
  const showErrorSnackbar = (payload: ErrorSnackbarConfig) => {
    config.value = payload;
    isShown.value = true;
  };

  const closeErrorSnackbar = () => {
    isShown.value = false;

    setTimeout(() => {
      config.value = undefined;
    }, 500);
  };

  return {
    config,
    isShown,

    showErrorSnackbar,
    closeErrorSnackbar,
  };
};
